module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Friedrich Nietzsche\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Friedrich Nietzsche (1844–1900) was a German philosopher. Though he began his career as a classical philologist studying Greek and Roman texts, Nietzsche went on to publish numerous influential works critiquing contemporary society. Central to his philosophy are the death of religion in the modern world and the notion of overcoming a system of morality that is based on the dichotomy between good and evil. In 1889 Nietzsche suffered a breakdown that resulted in nearly complete mental incapacitation. He died in 1900. "), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10FWg7G/tc-custom/9781504074728.jpg?1713498446477",
      "alt": "This image is the cover for the book Unpublished Letters"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unpublished Letters\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("This collection of personal correspondence provides a rare window into the private life of the toweringnineteenth-century philosopher.")])]), _c('p', [_vm._v("Friedrich Nietzsche was the most iconoclastic philosopher of modern history. He is known to the world as the scathingly brilliant provocateur behind such foundational works as "), _c('i', [_vm._v("Thus Spoke Zarathustra")]), _vm._v(", "), _c('i', [_vm._v("Beyond Good and Evil")]), _vm._v(", and "), _c('i', [_vm._v("Twilight of the Idols")]), _vm._v(". This was Nietzsche as he addressed himself to the public. But in this collection of his personal letters, we discover a very different man: Nietzsche the devoted son; the caring friend; the university student; the shy and distant lover.")]), _vm._v(" Comprised of correspondence between Nietzsche’s inner circle—including several revelatory letters to his sister—"), _c('i', [_vm._v("Unpublished Letters ")]), _vm._v("gives readers a never-before-seen look into the philosopher’s daily life.\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Philosophical Library\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0